module.exports = __webpack_public_path__ + "img/card@3x.6f4d5725.png";